import { render, staticRenderFns } from "./EmergencyMonitor.vue?vue&type=template&id=61ce7de6&scoped=true"
import script from "./EmergencyMonitor.vue?vue&type=script&lang=js"
export * from "./EmergencyMonitor.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMonitor.vue?vue&type=style&index=0&id=61ce7de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce7de6",
  null
  
)

export default component.exports